import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Row, Col, Breadcrumb, BreadcrumbItem, FormGroup, Input, Label, Button
} from 'reactstrap'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import {
  getReason, updateReason, deleteReason
} from '../../../actions/adminActions'
import Loading from '../../loading'
import Form from '../../../modules/Form'
import PropTypes from 'prop-types'

class AdminReasonEdit extends Component {
  componentDidMount (props) {
    this.props.getReason(this.props.match.params.id)
  }

  render () {
    if (this.props.admin.reason !== null) {
      return (

        <div>
          <Row className='page-title'>
            <Col>
              <h1>Edit Reason</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <Breadcrumb>
                <BreadcrumbItem><Link to='/admin/reasons'>Reasons</Link></BreadcrumbItem>
                <BreadcrumbItem active>Edit</BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
          <div className='content'>
            <Row>
              <Col lg={{ size: 6, offset: 0 }}>
                <Form id='details' submit={this.props.updateReason}>
                  <FormGroup>
                    <Label for='reason'>Reason</Label>
                    <Input type='text' name='reason' defaultValue={this.props.admin.reason.reason} id={'reason'} required placeholder='Reason' />
                    <div className='invalid-feedback' />
                    <Input type='hidden' name='label' id='label' value={this.props.admin.reason.label} />
                  </FormGroup>
                  <Input type='hidden' name='id' value={this.props.admin.reason.id} />
                </Form>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button color='primary' form='details' disabled={this.props.admin.submitting}>Update <span className='spinning' /></Button>
                {this.props.admin.reason.reason.toLowerCase() !== 'other' &&
                <Button className='ml-2 btn-sec' onClick={() => { this.props.deleteReason(this.props.admin.reason.id) }} disabled={this.props.admin.deleting}>Delete <span className='spinning' /></Button>
                }
              </Col>
            </Row>
          </div>
        </div>
      )
    } else {
      return (<Loading />)
    }
  }
}

AdminReasonEdit.propTypes = {
  getReason: PropTypes.func,
  updateReason: PropTypes.func,
  deleteReason: PropTypes.func,
  match: PropTypes.object,
  admin: PropTypes.object
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getReason,
      updateReason,
      deleteReason
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminReasonEdit))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminReasons/AdminReasonEdit.jsx